/* eslint-disable no-undef */
import moment from 'utils/momentInstanse'
import {
  CognitoUserPool,
  CognitoUser,
  AuthenticationDetails,
  CognitoRefreshToken,
  CognitoIdToken,
} from 'amazon-cognito-identity-js'

const poolData = {
  UserPoolId: process.env.REACT_APP_USER_POOL_ID,
  ClientId: process.env.REACT_APP_CLIENT_ID,
}

export const UserPool = new CognitoUserPool(poolData)
export class AWSService {
  static _user = null
  static _session = null

  static checkValidToken = (IdToken) => {
    const idToken = new CognitoIdToken({ IdToken })
    const exp = idToken.getExpiration()
    const _nowTime = moment().unix()
    return exp - _nowTime > 60
  }

  static getSession = () => {
    return new Promise((resolve, reject) => {
      const user = UserPool.getCurrentUser()

      if (user) {
        user.getSession((err, session) => {
          if (err) reject(err)
          this._session = session
          resolve(session?.idToken?.jwtToken)
        })
      } else {
        reject(null)
      }
    })
  }

  static getRefreshSession = () => {
    return new Promise((resolve, reject) => {
      const user = UserPool.getCurrentUser()
      if (user) {
        const refresh = new CognitoRefreshToken({
          RefreshToken: AWSService._session.refreshToken?.token,
        })
        user.refreshSession(refresh, (err, result) => {
          if (err) reject(err)
          AWSService._session = result
          resolve(result?.idToken?.jwtToken)
        })
      } else {
        reject(null)
      }
    })
  }

  static login = async (userData = {}) => {
    const user = new CognitoUser({
      Username: userData.login.toLowerCase(),
      Pool: UserPool,
    })
    const authDetail = new AuthenticationDetails({
      Username: userData?.login,
      Password: userData?.password,
    })

    // eslint-disable-next-line no-undef
    return new Promise((resolve, reject) => {
      user.authenticateUser(authDetail, {
        onSuccess: (data) => {
          AWSService._session = data
          resolve({
            type: 'success',
            data: data?.idToken?.jwtToken,
          })
        },
        newPasswordRequired: (data) => {
          AWSService._user = user
          resolve({
            type: 'new_password_recovery',
            data,
          })
        },
        onFailure: (data) => {
          reject(data)
        },
      })
    })
  }

  static logout = () => {
    const user = UserPool.getCurrentUser()
    AWSService._session = null
    if (user) {
      user.signOut()
    }
  }

  static restorePassword = (userName) => {
    return new Promise((resolve, reject) => {
      const user = new CognitoUser({
        Username: userName,
        Pool: UserPool,
      })

      user.forgotPassword(
        {
          onSuccess: (data) => {
            resolve(data)
          },
          onFailure: (err) => {
            reject(err)
          },
          inputVerificationCode: (data) => {
            resolve(data?.CodeDeliveryDetails?.Destination)
          },
        },
        {
          urlRedirect: process.env.REACT_APP_RESTORE_PASS_REDIRECT_URL,
        }
      )
    })
  }

  static completeNewPassword = (changePasswordData) => {
    const { password, userName = '' } = changePasswordData
    return new Promise((resolve, reject) => {
      AWSService._user.completeNewPasswordChallenge(
        password,
        {
          email: userName.toLowerCase(),
        },
        {
          onSuccess: (data) => {
            resolve(data.idToken.jwtToken)
          },
          onFailure: (err) => {
            reject(err)
          },
        }
      )
      AWSService._user = null
    })
  }

  static changePassword = (changePasswordData) => {
    const { password, code, userName = '' } = changePasswordData

    const user = new CognitoUser({
      Username: userName.toLowerCase(),
      Pool: UserPool,
    })

    return new Promise((resolve, reject) => {
      user.confirmPassword(code, password, {
        onSuccess: () => resolve(),
        onFailure: (err) => reject(err),
      })
    })
  }

  static changeCurrentPassword = (changePasswordData) => {
    const { oldPassword = '', newPassword = '' } = changePasswordData

    return new Promise((resolve, reject) => {
      const user = UserPool.getCurrentUser()

      if (user) {
        user.getSession((err, session) => {
          if (err) reject(err)
          user.setSignInUserSession(session)
        })
        user.changePassword(oldPassword, newPassword, (error, success) => {
          if (error) reject(error)
          resolve(success)
        })
      } else {
        reject(null)
      }
    })
  }
}
